// single source of truth for rendering money — avoids "$ 499" / parseInt(total) bugs
export const formatPrice = (value) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(Number(value) || 0);
